module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "auth-form-container"
  }, [(_vm.isSignIn) ? _c('login', {
    attrs: {
      "loginSsoGoogle": _vm.loginSsoGoogle,
      "switchAuthView": _vm.switchAuthView
    }
  }) : _c('register', {
    attrs: {
      "loginSsoGoogle": _vm.loginSsoGoogle,
      "switchAuthView": _vm.switchAuthView
    }
  }), _vm._v(" "), _c('reset'), _vm._v(" "), _c('registersuccessmodal')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-image"
  }, [_c('img', {
    staticClass: "landing",
    attrs: {
      "src": require("../../assets/landing.svg")
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0dcc29e7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dcc29e7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Home.vue
// module id = 1413
// module chunks = 1